<template>
  <div class="first">
    <!-- <Flow></Flow> -->
    <SCNews v-if="cityDetail.cityName == '上蔡县'" />
    <News v-else></News>
    <HTLink v-if="cityDetail.havaLink"></HTLink>
    <!-- <div class="right"> -->
    <!-- <Maps></Maps> -->
    <!-- <Gonggao></Gonggao> -->
    <!-- </div> -->
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import News from './First/轮播新闻.vue'
import SCNews from './First/上蔡轮播新闻.vue'
import Maps from './First/地图导航.vue'
import Gonggao from './First/公示公告.vue'
import Flow from './First/交易流程.vue'
import HTLink from './First/后台链接.vue'

export default {
  data () {
    return {
      showNews: false,
    }
  },
  components: {
    News,
    Maps,
    Gonggao,
    Flow,
    Header,
    HTLink,
    SCNews,
  },
  created () {
    this.showNews =
      sessionStorage.getItem('deptId') == this.cityDetail.deptId
  },
  mounted () { },
  computed: {},
  watch: {},
  methods: {},
}
</script>

<style scoped>
.first {
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  width: 100%;
  /* height: 450px; */
  margin: 20px 0;
  margin-bottom: 0;
  position: relative;
  /* background-color: red; */
}

.right {
  display: flex;
  width: 558px;
  /* height: 978px; */
  flex-flow: row wrap;
  align-content: space-between;
}
</style>
